import axios from 'axios';
import {
  RepairGetAllQuery,
  RepairGetAllGroupQuery,
  RepairUpdateProps,
  RepairUpdateImagesProps,
  IdProps,
} from '../types';

class RepairService {
  getAllGroup = (props: any) => axios.get<RepairGetAllGroupQuery>('/repairs/group', props);

  getAll = (props: any) => axios.get<RepairGetAllQuery>('/repairs', props);

  get = (id: string) => axios.get<{ data: RepairGetAllQuery['data'][number] }>(`/repairs/${id}`);

  update = ({ id, ...props }: RepairUpdateProps) => axios.patch(`/repairs/${id}`, props);

  setPrice = (props: RepairUpdateProps[]) => axios.patch(`/repairs/bulk/set-price`, props);

  complete = ({ id }: IdProps) => axios.patch(`/repairs/${id}/complete`);

  delete = ({ id }: IdProps) => axios.delete(`/repairs/${id}`);

  uploadImages = (props: RepairUpdateImagesProps) => {
    if (!props.photos.length) return true;

    const formData = new FormData();
    for (const i in props.photos.map((obj) => obj.file)) {
      formData.append('images', props.photos[i].file);
    }

    return axios.patch(`/repairs/${props.id}/upload-${props.action}-images`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };

  deleteImages = (props: RepairUpdateImagesProps) => {
    if (!props.photos.length) return true;

    return axios.patch(`/repairs/${props.id}/delete-images`, {
      names: props.photos.map((obj) => obj.name),
      imageCategory: props.action + 'Images',
    });
  };

  updateImages = async ({ id, photos = [], action }: RepairUpdateImagesProps) => {
    await this.deleteImages({
      id,
      photos: photos.filter((obj) => obj.action === 'delete'),
      action,
    });

    await this.uploadImages({
      id,
      photos: photos.filter((obj) => obj.action === 'upload'),
      action,
    });
  };
}

export const repairService = new RepairService();
